<div class="d-flex flex-column top-div justify-content-between w-100">
  <div class="d-flex justify-content-between align-items-center">
    <div class="w-100 d-flex align-items-center justify-content-between">
      <span class="accello-general-text6 d-flex align-items-center">
        {{ item?.name }} 
        <span
          *ngIf="item?.type === 'unique-from-duplicates'"
          class="ms-2 d-flex align-items-center"
          matTooltip="Test cases that are unique within duplicates"
          matTooltipPosition="below"
        >
          <img
            src="assets/images/virtusa-icons/circle-i.png"
            alt="info"
            class="info-icon"
          />
        </span>
      </span>      
      @if (item?.info) {
        <span matTooltip="{{ item.info }}" matTooltipPosition="above">
          <img 
            src="assets/images/virtusa-icons/circle-i.png" 
            alt="info" 
            class="info-icon"
          />
        </span>
      }      
      @if(item.isExpand){<img
          src="assets/images/virtusa-icons/card-expand-icon.svg"
          alt="download" (click)="expand(item?.type)" (keydown.enter)="expand(item?.type)"
        />}
    </div>
  </div>

  <div class="d-flex align-items-center">
    <span class="accello-header3">{{ item?.value }}</span>
    @if(item.isDownload){<img
        src="assets/images/virtusa-icons/download-icon.svg"
        alt="download" (click)="download(item?.type)" (keydown.enter)="download(item?.type)"
      />}
  </div>
</div>
